import React from 'react'
import { RegisterContext } from '@account/contexts/register'

export const useRegister = () => {
  const ctx = React.useContext(RegisterContext)
  if (!ctx) throw new Error('useRegistrationContext must be used within RegistrationProvider')
  return ctx
}
